import * as React from 'react';
import { ActivityBannerType } from '../../../common/__generated__/api';
import { useStores } from '../../../utils/hooks';
import { MessageBanner, getBannerByType } from '.';

export interface SearchMessageBannerProps {
  className?: string;
}

export const SearchMessageBanner: React.FC<SearchMessageBannerProps> = ({ className }) => {
  const { activitySearchStore } = useStores();
  const banners = getBannerByType(activitySearchStore, ActivityBannerType.ALERT);
  const classList = `all-x-margin-three all-b-margin-two ${className ? className : 'all-t-margin-one'}`;

  if (!banners || banners.length <= 0) {
    return null;
  }

  const renderSearchMessageBanner = banners.map((banner, index) => (
    <MessageBanner
      key={`banner-${index}`}
      headerText={banner.title}
      bodyText={banner.subtitle}
      className={classList}
      icon={banner.icon}
    />
  ));

  return <>{renderSearchMessageBanner}</>;
};
